import dayjs from 'dayjs'

import ru from 'dayjs/locale/ru'
import en from 'dayjs/locale/en'

export function setDayjsLocale(locale: 'ru' | 'en' | 'kz') {
  if (locale === 'ru') dayjs.locale(ru)
  if (locale === 'en') dayjs.locale(en)
  if (locale === 'kz') dayjs.locale(ru)
}

export default dayjs
